import createAxios from './axiosHttp';

function getOrdersList(pagination,filters) {
    const axios = createAxios();
    const user= JSON.parse(localStorage.getItem("user"));
    let urlPath = `customer/${user.extraData.customerId}/order`;
    if (pagination) {
        urlPath += `?page=${pagination.currentPage - 1}&limit=${pagination.rows}`;
    } else {
        urlPath += '?page=0&limit=20';
    }
    if (filters && filters.search) {
        urlPath += `&search=${encodeURIComponent(filters.search)}`;
    }
    if (filters && filters.status) {
        urlPath += `&status=${filters.status}`;
    }
    if (filters && filters.date.start) {
        urlPath += `&start_date=${filters.date.start}`
    }
    if (filters && filters.date.end) {
        urlPath += `&end_date=${filters.date.end}`
    }
    if (filters && filters.sort) {
        if(filters.sort.sort){
            urlPath += `&sort=${filters.sort.sort}`;
        }
        if(filters.sort.order){
            urlPath += `&order=${filters.sort.order}`;
        }
    }
    if (filters && filters.sga_registered) {
        urlPath += `&sga_registered=${filters.sga_registered}`
    }
    if (filters && filters.out_of_stock) {
        urlPath += `&out_of_stock=${filters.out_of_stock}`
    }
    return axios.get(urlPath);
}

function newOrder(body) {
    const axios = createAxios();
    const user = JSON.parse(localStorage.getItem("user"));
    let urlPath = `customer/${user.extraData.customerId}/order`;
    return axios.post(urlPath, body);
}

function updateOrder(body) {
    const axios = createAxios();
    const user = JSON.parse(localStorage.getItem("user"));
    let urlPath = `customer/${user.extraData.customerId}/order/${body._id}`;
    return axios.put(urlPath, body);
}

function getOrder(orderId) {
    const axios = createAxios();
    const user= JSON.parse(localStorage.getItem("user"));
    let urlPath = `customer/${user.extraData.customerId}/order/${orderId}`;
    return axios.get(urlPath);
}

function getOrdersAsExcel(filters, language){
    const axios = createAxios();
    const user= JSON.parse(localStorage.getItem("user"));
    let urlPath = `customer/${user.extraData.customerId}/order/${language}/report`;
    urlPath += `?page=0&limit=1000000`;
    if (filters && filters.search) {
        urlPath += `&search=${encodeURIComponent(filters.search)}`;
    }
    if (filters && filters.status) {
        urlPath += `&status=${filters.status}`;
    }
    if (filters && filters.date.start) {
        urlPath += `&start_date=${filters.date.start}`
    }
    if (filters && filters.date.end) {
        urlPath += `&end_date=${filters.date.end}`
    }
    if (filters && filters.out_of_stock) {
        urlPath += `&out_of_stock=${filters.out_of_stock}`
    }
    if (filters && filters.sga_registered) {
        urlPath += `&sga_registered=${filters.sga_registered}`
    }
    return axios.get(urlPath, {
        responseType: 'blob'
    });
}
function getTracking(orderId) {
    const axios = createAxios();
    let urlPath = `order/${orderId}/tracking`;
    return axios.get(urlPath);
}

function getResources(orderId) {
    const axios = createAxios();
    const user = JSON.parse(localStorage.getItem("user"));
    let urlPath = `customer/${user.extraData.customerId}/order/${orderId}/resources`;
    return axios.get(urlPath);
}

function downloadResource(orderId, fileName){
    const axios = createAxios();
    const user= JSON.parse(localStorage.getItem("user"));
    let urlPath = `customer/${user.extraData.customerId}/order/${orderId}/resources?filename=${fileName}`;
    return axios.get(urlPath, {
        responseType: 'blob'
    });
}

function getProgress(orderId) {
    const axios = createAxios();
    const user = JSON.parse(localStorage.getItem("user"));
    let urlPath = `customer/${user.extraData.customerId}/order/${orderId}/progress`;
    return axios.get(urlPath);
}

function getDeliveryNote(orderId){
    const axios = createAxios();
    const user= JSON.parse(localStorage.getItem("user"));
    let urlPath = `customer/${user.extraData.customerId}/order/${orderId}/delivery-note`;
    return axios.get(urlPath, {
        responseType: 'blob'
    });
}

function onHoldStatus(body, entityId){
    const axios = createAxios();
    const user= JSON.parse(localStorage.getItem("user"));
    let urlPath = `customer/${user.extraData.customerId}/order/${entityId}/onHold`;
    return axios.put(urlPath, body);
}

function cancel(orderId) {
    const axios = createAxios();
    const user= JSON.parse(localStorage.getItem("user"));
    let urlPath = `customer/${user.extraData.customerId}/order/${orderId}`;
    return axios.delete(urlPath);
}

function recover(orderId) {
    const axios = createAxios();
    const user= JSON.parse(localStorage.getItem("user"));
    let urlPath = `customer/${user.extraData.customerId}/order/${orderId}/recover`;
    return axios.put(urlPath);
}

export const orderService = { getOrdersList, getOrder, newOrder, updateOrder, getOrdersAsExcel,getTracking, getResources, downloadResource, getDeliveryNote, getProgress, onHoldStatus, cancel, recover };